let acc = document.getElementsByClassName('accordion')

for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener('click', function () {
    ;[...acc].forEach((el, index) => {
      if (index !== i) el.classList.remove('active')
    })
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle('active')
  })
}

let menuButton = document.querySelectorAll('.menu-button')
let nav = document.querySelector('.mob-nav')
let burger = document.querySelectorAll('.icon-burger')
let cross = document.querySelectorAll('.icon-cross')

menuButton.forEach((el, i) => {
  el.addEventListener('click', function () {
    burger[i].classList.toggle('visible')
    cross[i].classList.toggle('visible')
  })

  if (i === 0) {
    el.addEventListener('click', () => {
      nav.classList.toggle('header-visible')
    })
  }
})

const TABLET_WIDTH = 960
const APPEAR_ACTIVE_CLASS = 'show'
const navbarToggle = document.getElementById('other-product-pages')
const navigation = document.getElementsByClassName('nav-tabs')[0]
const footer = document.querySelector('.footer')

if (navbarToggle && navigation) {
  const children = navigation.children[0]
  navbarToggle.onchange = event => {
    if (event.currentTarget.checked) {
      navigation.classList.add(APPEAR_ACTIVE_CLASS)
    } else {
      navigation.classList.remove(APPEAR_ACTIVE_CLASS)
    }
  }
  children.onclick = event => event.stopPropagation()

  navigation.onclick = () => {
    navbarToggle.checked = false
    navigation.classList.remove(APPEAR_ACTIVE_CLASS)

    //индекс == 0 -- хэдр меню, индекс == 1 -- боттом меню
    burger[1].classList.toggle('visible')
    cross[1].classList.toggle('visible')
  }
}
// скрыть футер при первой загрузке странички, если уже появился нижний бар
const hideFooter = () => {
  if (window.innerWidth <= TABLET_WIDTH && navbarToggle && navigation) {
    footer.style.display = 'none'
  }
}
hideFooter()

window.addEventListener('resize', () => {
  if (window.innerWidth > TABLET_WIDTH) {
    if (navbarToggle) {
      navbarToggle.checked = false
    }
    if (navigation) {
      navigation.classList.remove(APPEAR_ACTIVE_CLASS)
    }
    footer.style.display = 'block'
  }
  hideFooter()
})

// onScroll sticky Header

// Get the header
const header = document.getElementById('headerDesktop')

// Get the offset position of the navbar
const sticky = header.offsetTop
let needScroll = true //
// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
const stickHeader = () => {
  if (window.scrollY > sticky) {
    header.classList.add('fixed')
  } else {
    header.classList.remove('fixed')
  }
}

window.addEventListener('scroll', () => {
  if (window.innerWidth > 960) stickHeader()
})

// scroll 1 screen down
const homeMainSlider = document.getElementById('home-main-slider')

// let scrollDownOneScreen = () => {
//   const height = window.innerHeight + header.offsetHeight
//   window.scrollBy({
//     top: height,
//     behavior: 'smooth'
//   })
// }
//scroll to section
const scrollToMainSlider = () => {
  homeMainSlider.scrollIntoView({
    behavior: 'smooth'
  })
}

document.querySelector('textarea')?.addEventListener('input', function () {
  this.style.height = 'auto'
  this.style.height = `${this.scrollHeight}px`
})
